import styled from "styled-components";

const AdminFilterSelect = styled.select`
  min-height: 42px;
  padding: 0.65rem 0.8rem;

  border:
    1px solid
    rgba(255, 255, 255, 0.13);

  border-radius: 12px;

  background: #151d31;
  color: #f7f7f7;

  outline: none;

  &:focus-visible {
    outline:
      3px solid
      rgba(137, 179, 255, 0.32);

    outline-offset: 1px;
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
`;

export default AdminFilterSelect;
